import { render, staticRenderFns } from "./UploadDoc.vue?vue&type=template&id=07087f3a&"
import script from "./UploadDoc.vue?vue&type=script&lang=js&"
export * from "./UploadDoc.vue?vue&type=script&lang=js&"
import style0 from "./UploadDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports